<template>
  <li class="list-item supplier-price">
    <div class="description">
      {{ descriptionText }}
    </div>

    <div class="total">
      {{ totalText }}
    </div>
  </li>
</template>

<script>
import SupplierPrice from 'models/SupplierPrice'

export default {
  props: {
    priceItem: {
      type: Object,
      required: true,
      validator: (prop) => prop instanceof SupplierPrice
    }
  },

  computed: {
    descriptionText () {
      return `${this.priceItem.quantity} x ${this.priceItem.description}` +
        ` @ ${this.priceItem.price} ${this.priceItem.currency}`
    },

    commissionText () {
      return `\n(less ${this.priceItem.netCommissionPercentage}% commission) -${this.priceItem.commissionValue} ${this.priceItem.currency}` +
             `\n(less ${this.priceItem.vatPercentage}% VAT thereon) -${this.priceItem.vatValue} ${this.priceItem.currency}`
    },

    totalText () {
      let totalText = `${this.priceItem.total} ${this.priceItem.currency}`
      if (this.priceItem.commission) totalText += ` ${this.commissionText}`
      return totalText
    }
  }
}
</script>
